import { createNamespacedHelpers } from 'vuex-composition-helpers'
const { useActions: useFilterActions, useGetters: useFilterGetters } = createNamespacedHelpers('filters')

export function useFiltersData() {
  const { fetchProductFilters } = useFilterActions(['fetchProductFilters'])
  const { productFiltersAsTree: productFilters } = useFilterGetters(['productFiltersAsTree'])
  async function loadProductFilters() {
    await fetchProductFilters()
  }
  return {
    loadProductFilters,
    productFilters
  }
}
